<section class="h-screen flex items-center justify-center">
  <div class="flex w-full h-full">
    <!-- Left: Form Section -->
    <div class="w-full lg:w-1/2 flex flex-col items-center justify-between bg-white p-6">
      <!-- Logo -->
      <div class="w-full max-w-lg flex justify-start">
        <img [src]="logoUrl" alt="Logo" class="h-20 w-52"/>
      </div>

      <!-- Form Container -->
      @if (showTwoFa) {
        <app-two-fa [data]="twoFaData"></app-two-fa>
      } @else {
        <div class="w-full max-w-lg text-left">
          <h4 class="!text-xl text-gray-700 font-light">Welcome To</h4>
          <h4 class="!text-2xl font-bold text-black mb-2">ProTeamMate<sup>TM</sup> Portal</h4>
          <p class="text-md text-gray-600 mb-5">Accelerate IT Talent Hiring with Smarter Automation</p>

          <form [formGroup]="loginForm" (ngSubmit)="login()" id="loginform" class="space-y-4">
            <!-- Email -->
            <div>
              <label for="email" class="block text-sm text-gray-700 mb-1">Email <span
                class="text-red-500">*</span></label>
              <input
                pInputText
                (change)="handleEmailChange()"
                formControlName="username"
                type="email"
                id="email"
                placeholder="username@mailid.com"
                class="w-full h-10 text-sm"
                required
              />
            </div>

            <!-- Password -->
            <div>
              <label for="password" class="block text-sm text-gray-700 mb-1">Password <span
                class="text-red-500">*</span></label>
              <p-password
                [class]="'w-full'"
                id="password"
                [toggleMask]="true"
                [feedback]="false"
                formControlName="password"
                inputId="password"
                placeholder="********"
                (change)="handlePasswordChange()"
                styleClass="w-full"
                inputStyleClass="w-full h-10 text-sm"
              ></p-password>
              <a class="text-sm text-primary mt-1 block text-right no-underline" [routerLink]="getForgotPassword()">Forgot
                Password?</a>
              @if (errorMessage) {
                <div class="text-red-500 text-center mt-2 text-sm">{{ errorMessage }}</div>
              }
            </div>
            <div class="flex item-center justify-center">
              <p class="m-0 p-0">Don't have an account?
                <a class="text-sm text-primary text-right no-underline" [routerLink]="getRegisterUser()">Register Now</a></p>
            </div>
            <!-- Submit Button or Loader -->
            <div>
              <p-button
                styleClass="w-full"
                type="submit"
                label="Login"
                class="w-full"
                [disabled]="showLoader"
              ></p-button>
            </div>
          </form>
        </div>
      }

      <!-- Footer Placeholder -->
      <div>
        <app-footer></app-footer>
      </div>
    </div>

    <!-- Right: Image Section -->
    <div
      class="hidden lg:flex w-1/2 items-center justify-center relative"
      style="background: linear-gradient(49deg, #1177BD -10.76%, #24419B 39.14%, #24419B 53.75%, #24419B 78.54%, #1177BD 110.95%), #FFF;"
    >
      <!-- Image or Branding -->
      <div class="flex items-center justify-center">
        <img src="assets/loginImages/ClientLoginBackground.png" alt="Background Image" class="max-w-[80%] h-auto"/>
      </div>
    </div>

  </div>
</section>
